export function getUtcOffset() {
	// getTimezoneOffset returns a negative number when there is a POSITIVE
	// UTC offset. WHY???
	return -1 * new Date().getTimezoneOffset();
	// return -300;
}
